import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-310">
      {/* Subtle dot pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#0EA5E9 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-311"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-312">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-313">
          <div className="order-2 lg:order-1" data-id="element-314">
            <div className="relative aspect-video rounded-2xl overflow-hidden bg-slate-100 shadow-2xl border border-slate-200 group" data-id="element-315">
              {/* Background Image */}
              <img src="https://cdn.magicpatterns.com/uploads/kTVgaSHJCuLL4tem47UsLE/rp0Tb14MtHr94d_aH0bR-.png" alt="Heated driveway system in action" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-316" />

              {/* Overlay for text readability */}
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors duration-500" data-id="element-317"></div>

              {/* Placeholder for Solution Image with hover effect */}
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-318">
                <div className="text-center relative z-10" data-id="element-319">
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-white/90 backdrop-blur shadow-lg flex items-center justify-center" data-id="element-320">
                    <svg className="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-321">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-322" />
                    </svg>
                  </div>
                  <p className="text-white font-bold text-lg drop-shadow-md" data-id="element-323">
                    Radiant Heating System
                  </p>
                  <p className="text-sm text-slate-200 mt-1 drop-shadow-md" data-id="element-324">
                    Cross-section view
                  </p>
                </div>
                {/* Decorative lines representing heating cables - made more subtle */}
                <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-325">
                  <path d="M0,20 Q25,40 50,20 T100,20" stroke="white" strokeWidth="2" fill="none" data-id="element-326" />
                  <path d="M0,40 Q25,60 50,40 T100,40" stroke="white" strokeWidth="2" fill="none" data-id="element-327" />
                  <path d="M0,60 Q25,80 50,60 T100,60" stroke="white" strokeWidth="2" fill="none" data-id="element-328" />
                  <path d="M0,80 Q25,100 50,80 T100,80" stroke="white" strokeWidth="2" fill="none" data-id="element-329" />
                </svg>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 space-y-6" data-id="element-330">
            <div className="inline-block rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary border border-primary/20" data-id="element-331">
              The Modern Solution
            </div>
            <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-332">
              Intelligent Radiant Heating Technology
            </h2>
            <p className="text-lg text-slate-600" data-id="element-333">
              Our heated driveway systems use advanced radiant technology to
              sense moisture and temperature, automatically activating to melt
              snow and ice before it accumulates.
            </p>

            <ul className="space-y-4 mt-8" data-id="element-334">
              {['Fully automated sensors detect snow and ice instantly', 'Energy-efficient operation only runs when needed', 'Compatible with asphalt, concrete, and paver driveways', 'Zero maintenance required after installation'].map((item, i) => <li key={i} className="flex items-start gap-3 group" data-id="element-335">
                  <div className="mt-1 h-5 w-5 rounded-full bg-green-100 flex items-center justify-center shrink-0 group-hover:bg-green-200 transition-colors" data-id="element-336">
                    <Check className="h-3 w-3 text-green-600" data-id="element-337" />
                  </div>
                  <span className="text-slate-700 group-hover:text-slate-900 transition-colors" data-id="element-338">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}